// import { isEmpty } from 'lodash'

export const cadastroCliente = (state) => state.cadastro



// WEBPACK FOOTER //
// ./src/domain/leiloes/store/getters.js